import React from 'react';
import PropTypes from 'prop-types';

import RouteMonitor from '../RouteMonitor';

const Loader = ({ zendeskWidget, location }) => (
  <RouteMonitor
    zendeskWidget={zendeskWidget}
    pathname={location.pathname}
  />
);

Loader.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  zendeskWidget: PropTypes.shape({
    loaded: PropTypes.bool,
  }).isRequired,
};
Loader.defaultProps = {
  location: {},
};

export default Loader;
